import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { Injectable } from '@angular/core';
import { MedicalToolSetModel } from "../medicalToolSet.model";
import { MedicalToolSetSummaryConverter } from "./medicalToolSetSummary.converter";
import {
    MedicalSterilizationSummaryConverter
} from "../../../../sterilization/api/entity/converter/medicalSterilizationSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class MedicalToolSetConverter extends HttpModelConverter<MedicalToolSetModel> {
    constructor(private toolSetSummaryConverter: MedicalToolSetSummaryConverter,
                private sterilizationSummaryConverter: MedicalSterilizationSummaryConverter) {
        super();
    }
    protected createInstance(): MedicalToolSetModel {
        return new MedicalToolSetModel();
    }
    protected enrichObject(result: MedicalToolSetModel, src: MedicalToolSetModel) {
        result.summary = this.toolSetSummaryConverter.convert(src.summary);
        result.sterilization = this.sterilizationSummaryConverter.convert(src.sterilization);
    }
}

